import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  methodRow: {
    marginTop: theme.spacing(2)
  },
  note: {
    display: 'block',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  hint: {
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    cursor: 'help'
  }
}));

export default useStyles;
